export const AI_PANEL_WIDTH = '36vw';
export const AI_PANEL_ANIMATION_DURATION_MS = 300;
